import { min } from "lodash";
import { IPolicy, IPolicyObject, PolicyObjectTypeOptions } from "./ewpolicy";


export enum UserRole {
    Customer = 1,
    Attendant = 2,
    Owner = 3,
    Admin = 4,
    SalesPerson = 5,
    Account_Manager = 6,
    Support = 7
};

export interface ILocationSummary extends IPolicyObject {
    id: number,
    name: string,
    uuid: string, //guid
    removed: boolean,
    deleted: boolean,
    tz_offset: number
}

/**
 * @param fromCookie Indicates if user was pulled from a cookie
 * @param initialPath If valued, indicates the initial landing path on first entry
 * @param authorized Indicates if the user is authenticated/authorized.  It is possible to have a user
 */
export interface IUser extends IPolicyObject {
    id?: number;
    fromCookie: boolean;
    initialPath?: string;
    authorized?: boolean;
    displayName?: string;
    currentLocation?: ILocationSummary | null;
    role?: UserRole | null;
    locations?: ILocationSummary[] | null;
    uuid?: string;
    pool?: number;
};


export interface IUserState {
    user: IUser;
    setUser: React.Dispatch<React.SetStateAction<IUser>>;
};

export interface ICredential {
    uuid: string | null;
    user_id: number;
    user_uuid: string;
    pool: number;
    token: string | null;
    attempts: number;
    created_at: Date | null;
    expired_at: Date | null;
    renew_at: Date | null;
    updated_at: Date | null;
    locked: boolean;
    provider: string;
}

export interface ILoginCreds {
    token: string;
    credential: string;
  }

export interface IPermissionChecker {
    (source: IUser, setUser: (updated: IUser)=>any): Promise<boolean>
};

export enum AuthenticationOptions {
    Success = 0,
    AccountLocked = 1,
    CredentialLocked = 2,
    RenewCredential = 3,
    CredentialExpired = 4,
    InvalidCredential = 5,
    ExceededMaxAttempts = 6,
    NoMatch = 7,
    Unknown = 8,
    Unauthenitcated = 9
}

export enum ChangeCredentialResultOptions
{
    Success = 0,
    InvalidToken = 1,
    InsufficientComplexity = 2,
    Unknown = 3,
    DuplicateToken = 4,
    UnsupportedCredentialProvider = 5

}

export interface IAuthResult {
    result: AuthenticationOptions,
    user_id: number | null
};

export interface IChangeCredentialResult {
    result: ChangeCredentialResultOptions,
    credential: ICredential | null
}
